import { IProductObject } from '@features/categories/typescript';
import GoogleTagManagerItemList from '@reaffiliates/GoogleTagManager/GoogleTagManagerItemList';
import CreateProductItems from '@utils/createProductItems';
const ReaffiliatesSelectItem = (product: IProductObject, category: string, priceListName: string, listingType: string, listingId: number) => {
  GoogleTagManagerItemList(CreateProductItems(product, category, priceListName), listingType, listingId, 'select_item');
};
export default ReaffiliatesSelectItem;